export default __webpack_public_path__ + "static/media/eyecatch_docx.b52c38bd.png";